'use strict';

(function($) {
  var $body = $('body');

  function initNavToggle() {
    $('#headerNavControl').on('click', (e) => {
      e.preventDefault();
      $('body').toggleClass('headerNavOpen');
      $('html').toggleClass('headerNavOpen');
      $('#headerNavControl').text($body.hasClass('headerNavOpen') ? 'Close Nav' : 'Open Nav');
    });
  }
  
  function init() {
    initNavToggle();
  }
  
  $(init);
})(jQuery);